import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8003'
    : 'https://rbmchemicals.com';

const CategoryPage = () => {
    const { categoryName } = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        // Dynamic BASE_URL ke sath live/local API URL
        fetch(`${BASE_URL}/api/get_products_by_category/${encodeURIComponent(categoryName)}/`)
            .then((res) => res.json())
            .then((data) => {
                // Agar array mein data mila, toh pehla product set karein
                if (Array.isArray(data) && data.length > 0) {
                    setProduct(data[0]);
                } else {
                    setProduct(null);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error:", err);
                setLoading(false);
            });
    }, [categoryName]);

    if (loading) return <div className="text-center py-20 text-xl">Loading...</div>;
    if (!product) return <div className="text-center py-20 text-xl text-red-600">No products found in this category.</div>;

    const renderList = (text) => {
        if (!text) return null;
        return (
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
                {text.split('|').map((item, index) => <li key={index}>{item.trim()}</li>)}
            </ul>
        );
    };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Banner Section */}
            <div className="relative h-[300px] w-full flex items-center justify-center bg-gray-900 bg-cover bg-center"
                style={{ backgroundImage: `url('/banner-image.jpg')` }}>
                <div className="absolute inset-0 bg-black bg-opacity-60"></div>
                <h1 className="relative z-10 text-white text-5xl font-bold uppercase tracking-wider text-center px-4">
                    {product.name}
                </h1>
            </div>

            <div className="container mx-auto py-16 px-10">
                <div className="bg-white p-10 rounded-xl shadow-lg grid md:grid-cols-2 gap-12 mb-12">
                    <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-80 object-cover rounded-lg shadow-md"
                    />
                    <div>
                        <h2 className="text-3xl font-bold text-blue-900 mb-6 border-l-4 border-orange-500 pl-4">Product Description</h2>
                        <p className="text-gray-700 text-lg leading-relaxed mb-8">{product.description}</p>
                        <button onClick={() => navigate('/enquiry')}
                            className="bg-orange-500 text-white px-10 py-4 rounded font-bold text-lg hover:bg-orange-600 transition shadow-lg">
                            ENQUIRY NOW
                        </button>
                    </div>
                </div>

                {/* Features, Applications, Benefits */}
                <div className="grid md:grid-cols-3 gap-8">
                    {product.features && (
                        <div className="bg-white p-6 rounded-lg shadow border-t-4 border-blue-500">
                            <h3 className="text-xl font-bold text-blue-900 mb-4">Key Features</h3>
                            {renderList(product.features)}
                        </div>
                    )}
                    {product.applications && (
                        <div className="bg-white p-6 rounded-lg shadow border-t-4 border-green-500">
                            <h3 className="text-xl font-bold text-blue-900 mb-4">Applications</h3>
                            {renderList(product.applications)}
                        </div>
                    )}
                    {product.benefits && (
                        <div className="bg-white p-6 rounded-lg shadow border-t-4 border-orange-500">
                            <h3 className="text-xl font-bold text-blue-900 mb-4">Benefits</h3>
                            {renderList(product.benefits)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CategoryPage;